class StaticData {
  public getVoucherKostenSetItems() {
    return [
      {
        expenseHead: "Establishment / HR",
        subExpenseHeads: [
          'Salaries - Full Time - Waqfeen',
          'Salaries - Full Time - Non Waqfeen',
          'Salaries - Part Time',
          'Eidi & Eid Gifts',
          'Services'
        ]
      },
      {
        expenseHead: "Travel",
        subExpenseHeads: [
          'Travel - Air',
          'Travel - Public Transport',
          'Travel - Taxi',
          'Travel - Visa & Immigration',
          'Travel - Car'
        ]
      },
      {
        expenseHead: "Ziafat",
        subExpenseHeads: [
          'Ziafat - General',
          'Ziafat - Meeting',
          'Ziafat - Cantine',
          'Ziafat - Event'
        ]
      },
      {
        expenseHead: "Rent",
        subExpenseHeads: [
          'Rent - Lease Equipment',
          'Rent - Residential Properties',
          'Rent - Vehicle',
          'Rent - Others',
          'Rent - Hall',
          'Rent - Hotel'
        ]
      },
      {
        expenseHead: "Taxes",
        subExpenseHeads: [
          'Taxes - Vehicles',
          'Taxes - General'
        ]
      },
      {
        expenseHead: "Legal and Professional",
        subExpenseHeads: [
          'Legal & Professional - Legal Fee',
          'Legal & Professional - Accounting Fee'
        ]
      },
      {
        expenseHead: "Printing",
        subExpenseHeads: [
          'Printing - Literature',
          'Printing - Others'
        ]
      },
      {
        expenseHead: "Stationary",
        subExpenseHeads: [
          'Stationary'
        ]
      },
      {
        expenseHead: "Postage",
        subExpenseHeads: [
          'Postage - Others',
          'Postage - Courier Services'
        ]
      },
      {
        expenseHead: "Communications",
        subExpenseHeads: [
          'Telephone - Landline',
          'Telephone - Mobile',
          'Broadband / Internet'
        ]
      },
      {
        expenseHead: "Books and news papers",
        subExpenseHeads: [
          'Newspaper',
          'Books & Refrence Material',
          'Periodicals/Subscriptions'
        ]
      },
      {
        expenseHead: "Repair & Maintenance",
        subExpenseHeads: [
          'R&M - Vehicles Repair',
          'R&M - Janitorial Service',
          'R&M - Garbage Disposal',
          'R&M - Equipment',
          'R&M - Residential Properties'
        ]
      },
      {
        expenseHead: "Utilities",
        subExpenseHeads: [
          'Utilities - Electricity',
          'Utilities - Gas & Oil',
          'Utilities - Water & Sewage'
        ]
      },
      {
        expenseHead: "IT Equipment",
        subExpenseHeads: [
          'IT Equipment - Hardware',
          'IT Equipment - Accessories',
          'IT Equipment - Software'
        ]
      },
      {
        expenseHead: "Equipment",
        subExpenseHeads: [
          'Equipment - Multimedia',
          'Equipment - Office',
          'Equipment - Others'
        ]
      },
      {
        expenseHead: "Media",
        subExpenseHeads: [
          'Media - Advertisement',
          'Media - Web hosting & Related Charges',
          'Media - Others'
        ]
      },
      {
        expenseHead: "General",
        subExpenseHeads: [
          'General - Misc',
          'General - Household Items',
          'General - Prizes & Trophies'
        ]
      },
      {
        expenseHead: 'Sada\'qaat',
        subExpenseHeads: [
          'Sada\'qaat'
        ]
      },
      {
        expenseHead: 'Insurance',
        subExpenseHeads: [
          'Insurance - Property',
          'Insurance - Vehicle',
          'Insurance - Equipment'
        ]
      },
      {
        expenseHead: 'Bank Charges',
        subExpenseHeads: [
          'Bank Charges - Acct Maintainance Fee',
          'Bank Charges - Card Fee'
        ]
      },
      {
        expenseHead: 'Assets',
        subExpenseHeads: [
          'Assets - Furnitures',
          'Assets - Vehicle Purchased',
          'Assets - Others'
        ]
      },
    ]
  }

  public getAllMajalis() {
    return [
      'Baitus Sabuh Nord',
      'Recklinghausen',
      'Wiesbaden Ost',
      'Donaueschingen',
      'Bad Kreuznach',
      'Sinsheim',
      'Rahlstedt',
      'Bruchsal',
      'Euskirchen',
      'Hannover',
      'Chemnitz',
      'Groß Umstadt',
      'Masroor Hostel',
      'Minden',
      'Immenhausen',
      'Rödelheim',
      'Kaiserslautern',
      'Kempten',
      'Speyer',
      'Dithmarschen',
      'Dreieich',
      'Flörsheim',
      'Simbach am Inn',
      'Hausen',
      'Bruchköbel',
      'Calw',
      'Grünberg',
      'Iserlohn',
      'Langenselbold',
      'Balingen',
      'Düren',
      'Karlsruhe',
      'Eidelstedt',
      'Karben',
      'Esslingen',
      'Gummersbach',
      'Worfelden',
      'Trier',
      'Rüsselsheim Nord',
      'Schleswig',
      'Rödermark',
      'Oberursel',
      'Berg',
      'Mülheim an der Ruhr',
      'Wiesbaden Nord',
      'Weingarten',
      'Alzey',
      'Schwetzingen',
      'Bonn',
      'Delmenhorst',
      'Rüsselsheim-Hasengrund',
      'Gräfenhausen',
      'Viernheim',
      'Herford',
      'Lurup',
      'Wittlich',
      'Berlin Südost',
      'Dietzenbach',
      'Bad Soden',
      'Regensburg',
      'Frankfurt-Griesheim',
      'Bad Vilbel',
      'Böblingen',
      'Fulda',
      'Riedberg',
      'Homburg Saar',
      'Hof',
      'Berlin Nordwest',
      'Erzhausen',
      'Bad Schwalbach',
      'Rheine',
      'Gießen',
      'Heilbronn',
      'Stade City',
      'Billstedt',
      'Hanau',
      'Waiblingen',
      'Betzdorf',
      'Klein Gerau',
      'Sohren',
      'Raunheim Süd',
      'Pinneberg',
      'Offenbach',
      'Niedernhausen',
      'Baitus Sabuh Süd',
      'Meschede',
      'Wiesbaden Mitte',
      'Waldshut',
      'Viersen',
      'Pforzheim',
      'Pulheim',
      'Buxtehude',
      'Rüsselsheim-Königstädten',
      'Eppertshausen',
      'Lampertheim',
      'Bielefeld',
      'HH-Moschee',
      'Nürnberg',
      'Goldstein',
      'Bad Nauheim',
      'Bietigheim',
      'Bad Hersfeld',
      'Freinsheim',
      'Gemünden',
      'Frankenberg',
      'Heidelberg',
      'Soltau',
      'Plauen-Zwickau',
      'Münster (Hessen)',
      'Bad Homburg',
      'Paderborn',
      'Barmbek',
      'Nuur Moschee',
      'Gelnhausen',
      'Stuttgart',
      'Bergisch Gladbach',
      'Büttelborn',
      'Neuwied',
      'Raunheim Nord',
      'Mahdiabad',
      'Obertshausen',
      'Limburg',
      'Dortmund',
      'Reichelsheim',
      'Ulm-Donau',
      'Stolberg',
      'Mosbach',
      'Wetzlar',
      'Olpe',
      'Bremerhaven',
      'Bingen',
      'Dieburg',
      'Bensheim',
      'Ahaus',
      'HH-Mitte',
      'Neuburg',
      'Ginnheim',
      'Schlüchtern',
      'Aalen',
      'Vechta',
      'Frankenthal',
      'Frontenhausen',
      'Gaggenau',
      'Aachen',
      'Oldenburg',
      'Leipzig',
      'Weiterstadt',
      'Heppenheim',
      'Osnabrück',
      'Bait-ur-Rasheed',
      'Nordweststadt',
      'Friedberg',
      'Renningen',
      'Wabern',
      'Mörfelden',
      'Montabaur',
      'Ginsheim',
      'Lübeck',
      'Neu-Isenburg',
      'Hofheim',
      'Ratingen',
      'Mannheim',
      'Wetter',
      'Borken',
      'Nidda',
      'Reutlingen-Nord',
      'Rüsselsheim West',
      'Darmstadt',
      'Mühlheim am Main',
      'Usingen',
      'Heimfeld',
      'Lüdenscheid',
      'Bremen',
      'München',
      'Eschersheim',
      'Aschaffenburg',
      'Wiesbaden West',
      'Eich',
      'Erlangen',
      'Freiburg',
      'Radevormwald',
      'Lüneburg',
      'Erfurt',
      'Reinheim',
      'Stockstadt',
      'Nordhorn',
      'Nied',
      'Florstadt',
      'Göppingen',
      'Neuhof',
      'Nauheim',
      'Ludwigshafen',
      'Mainz',
      'Kiel',
      'Langen',
      'Hattersheim',
      'Altona',
      'Marburg',
      'Bochum',
      'Maintal',
      'Radolfzell',
      'Neuss',
      'Lörrach',
      'Rüsselsheim Süd',
      'Babenhausen',
      'Seligenstadt',
      'Steinbach',
      'Harburg',
      'Leverkusen',
      'Groß-Gerau',
      'Kitzingen',
      'Bornheim',
      'Soest',
      'Wiesbaden Süd',
      'Reutlingen-Süd',
      'Bad Marienberg',
      'Augsburg',
      'Wandsbek',
      'Eppelheim',
      'Brühl',
      'Jesteburg',
      'Dresden',
      'Pfungstadt',
      'Riedstadt',
      'Münster',
      'Büdingen',
      'Ellwangen',
      'Kassel',
      'Zeilsheim',
      'Koblenz-Tahir',
      'Koblenz-Masroor',
      'Husum',
      'Heusenstamm',
      'Friedrichsdorf',
      'Würzburg',
      'Höchst',
      'Herborn',
      'Bocholt',
      'Altenstadt',
      'Ebingen',
      'Düsseldorf',
      'Lahr',
      'Fühlsbüttel',
      'Köln',
      'Trebur',
      'Rüsselsheim Ost',
      'Da-Griesheim',
      'Rodgau',
      'Rüdesheim',
    ]
  }

  public getAllRegions() {
    return [
      'Württemberg-Nord',
      'Südwesthessen',
      'Hessen-Mitte',
      'Nordrhein-West',
      'Wiesbaden',
      'Südosthessen',
      'Hamburg',
      'Nordrhein-Ost',
      'Wetterau/Main-Kinzig',
      'Südhessen',
      'Bayern',
      'Nordhessen',
      'Schleswig-Holstein',
      'Baden',
      'Westfalen-Süd',
      'Niedersachsen',
      'Sachsen-Brandenburg',
      'Westfalen-Nord',
      'Nasir Bagh (Groß-Gerau)',
      'Rüsselsheim',
      'Württemberg-Süd',
      'Taunus',
      'Muqami',
      'Rheinland-Pfalz'
    ]
  }

  public getAllVoucherStatus() {
    return [
      'NAZIMEALA_IJTEMA_APPROVAL_PENDING',
      'DECLINED_BY_NAZIMEALA_IJTEMA',
      'MUHASIB_APPROVAL_PENDING',
      'DECLINED_BY_MUHASIB',
      'CREATED_BY_MOHTAMIM',
      'SADR_MAJLIS_APPROVAL_PENDING',
      'MAAL_APPROVAL_PENDING',
      'PAID'
    ];
  }
}





export default new StaticData();
